import defaultConsents from '../configs/consents/defaultConsents.json';
import RequestCachedError from '../errors/requestCachedError';
import {selectLanguageCode} from '../state/selectors/session';
import {setConsents, setConsentsFlagsValues, setIsConsentsReceiveInProgress} from '../state/slice/session';
import {dispatch, getState} from '../state/store';
import damService from './dam/damService';
import iapClientService from './iap/iapClientService';
import iapMappingService from './iap/iapMappingService';
import log from './logger/log';
import notificationService from './notificationService';
import uamClientService from './uam/uamClientService';

const getConsents = async () => {
    dispatch(setIsConsentsReceiveInProgress(true));

    try {
        const consents = await iapClientService.getIapConsents();

        log.debug('consentsService: Successfully received IAP consents');

        dispatch(setConsents(consents));
    } catch (e) {
        log.error('consentsService: Failed to receive IAP consents. Used default consents', e?.message);

        dispatch(setConsents(iapMappingService.consentsMapping(defaultConsents)));
    }

    await updateUserConsentsFlagValues();

    dispatch(setIsConsentsReceiveInProgress(false));
};

const updateConsents = async (consentsFlagsValues, isOnlineRequest) => {
    try {
        await uamClientService.putUserConsents(consentsFlagsValues, isOnlineRequest);
    } catch (e) {
        if (e instanceof RequestCachedError) {
            dispatch(setConsentsFlagsValues(consentsFlagsValues));

            notificationService.showRequestSavedSuccess();
        } else {
            throw e;
        }
    }

    await updateUserConsentsFlagValues();
};

const updateUserConsentsFlagValues = async () => {
    try {
        await damService.getUserConsents();
    } catch (e) {
        notificationService.showRequestError();
    }
};

const parseConsentContent = (content) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const links = doc.querySelectorAll('a');

    links.forEach((link) => {
        link.classList.add('underline');
        link.setAttribute('target', '_blank');
    });

    return doc.body.innerHTML;
};

const mapConsentsValues = (consents, isAccepted) => {
    const consentsFlagsValues = consents.map((consent) => mapConsentFlagsValues(consent.consentFlags, isAccepted));

    // [{flag: true}, ...] -> {flag: true, ...}
    return consentsFlagsValues.reduce((acc, flags) => ({...acc, ...flags}), {});
};

// [flag, ...] -> {flag: true, ...}
const mapConsentFlagsValues = (consentFlags, isAccepted) => {
    return consentFlags.reduce((acc, flag) => {
        acc[flag] = isAccepted;

        return acc;
    }, {});
};

const checkIsConsentsUpdated = (updatedFlagsValues, flagsValues) => {
    for (const key in updatedFlagsValues) {
        if (updatedFlagsValues[key] !== flagsValues[key]) {
            return true;
        }
    }
    return false;
};

const getConsentItemContent = (texts) => {
    const selectedLanguageCode = selectLanguageCode(getState());

    const itemContent = texts.find(({languageCode}) => languageCode === selectedLanguageCode);

    if (itemContent) return itemContent;

    return texts[0];
};

export default {
    getConsents,
    updateConsents,
    parseConsentContent,
    mapConsentFlagsValues,
    mapConsentsValues,
    checkIsConsentsUpdated,
    getConsentItemContent,
    updateUserConsentsFlagValues,
};
